<template>
  <div>
    <SearchTargets @targetChose="updateTarget" />
  </div>
</template>

<script>
import SearchTargets from "./SearchTargets";
import { mapActions } from "vuex";

export default {
  name: "SearchOptions",

  components: {
    SearchTargets,
  },

  methods: {
    ...mapActions("options", ["setOptionsTarget"]),

    updateTarget(target) {
      this.$root.$emit("focusSearch");
      this.setOptionsTarget(target);
    },
  },
};
</script>
